import React from 'react';
import styled, {css} from 'styled-components';

// Constants
import { constants } from 'constants/index';

const FieldWrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    margin-top: 10px;
`;

const TextAreaWrapper = styled.textarea`
    resize: none;
    border: 1px solid ${constants.color.grey5};
    width: 430px;
    height: 150px;
    border-radius: 5px;
    padding: 10px;
    font-size: 1.6em;
    line-height: 1.6em;
    ${props =>
        props.errorMessage && css` border-bottom: 1px solid red;`
    }
    &::placeholder{
        color: ${constants.color.grey34};
    }
`;

const ValidationMessageWrapper = styled.label`
    font-size: 1.6em;
    line-height: 1.6em;
    color: red;
    transition: 0.28s;
    overflow: hidden;
    color: red;
    font-style: italic;
    margin-right: auto;
`

const FormTextArea = ({value, onChange, name, label, errorMessage, required,...styleProps}) => {
    return (
        <FieldWrapper
            style={styleProps.containerProps}
        >
            <TextAreaWrapper
                value={value}
                onChange={onChange}
                name={name}
                style={styleProps.textAreaProps}
                placeholder={label}
                required={required}
                errorMessage={errorMessage}
            />
            <ValidationMessageWrapper test-label='error-label'>{errorMessage}</ValidationMessageWrapper>
        </FieldWrapper>
    )
}

export default FormTextArea;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Components/FormTextArea.js